<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Set Pin</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div *ngIf="activeSlide === slides.PIN_CREATED" sxPadding="medium">

    <div sxBackground="light" sxPadding="medium" sxWidth="full" sxMaxWidth="500px" sxHeight="full" sxRadius="medium">
      <div sxCol sxGap="10px" sxAlign="center" sxJustify="center">
        <div sxAlign="center" sxJustify="center" sxCircle="100px" sxBackground="base-shade" sxCenterize="col">
          <ion-icon name="key-outline" sxColor="three" sxTextSize="50px"></ion-icon>
        </div>

        <div sxRow sxAlign="center" sxJustify="center" sxGap="10px">
          <p sxTextSize="medium" sxColor="three">Encryption Setup</p>
          <ion-icon name="checkmark-circle" sxColor="success" sxTextSize="20px"></ion-icon>
        </div>

        <div>
          <p sxWhiteSpace="wrap" sxTextSize="small" sxColor="two" sxBorderColor="one" sxBorderWidth="1px"
            sxWidth="400px" sxPadding="medium" sxRadius="medium">
            {{encryptionKeys?.publicKey}}</p>
        </div>
        <p sxTextAlign="left" sxColor="two">Setup Date: {{encryptionKeys?.createTime | date:'dd MMM yyyy'}}</p>
        <super-button type="clear" sxWidth="full" [action]="generateEncryptionKey"
          iconEnd="arrow-forward-outline">Continue</super-button>
      </div>
    </div>

  </div>

  <div *ngIf="activeSlide === slides.INPUT_PIN" sxPadding="medium" sxCol sxGap="10px" sxWidth="full" sxAlign="center"
    sxJustify="center">


    <div sxBackground="light" sxPadding="medium" sxWidth="full" sxMaxWidth="500px" sxHeight="full" sxRadius="medium"
      sxCol sxGap="10px" sxAlign="center" sxJustify="center">

      <div sxAlign="center" sxJustify="center" sxCircle="100px" sxBackground="base-shade" sxCenterize="col">
        <ion-icon name="lock-closed-outline" sxColor="three" sxTextSize="50px"></ion-icon>
      </div>
      <h3 sxMargin="0" sxPadding="0" sxTextAlign="center" sxColor="two" sxTextSize="small">Please carefully setup a
        6-Digit pin for your account</h3>

      <super-input sxWidth="full" [(value)]="passwordInput" type="password" label="Set Pin"></super-input>
      <super-input sxWidth="full" [(value)]="confirmPasswordInput" type="password" label="Confirm Pin"></super-input>


      <div sxRow sxGap="10px" sxMargin="40px 0 20px" sxBorderWidth="1px" sxBorderColor="one" sxPadding="medium"
        sxRadius="medium">

        <div sxAlign="center" sxJustify="center" sxCircle="60px" sxBackground="base-shade" sxCenterize="col">
          <ion-icon name="refresh-outline" sxColor="three" sxTextSize="30px"></ion-icon>
        </div>

        <div sxCol sxGap="10px">
          <h1 sxTextSize="medium" sxMargin="0" sxPadding="0">Do you want to setup a recovery pin?</h1>
          <p sxTextSize="small" sxColor="two" sxMargin="0">Setting up a recovery pin allows you to recover your account
            in case you
            forget your
            primary pin</p>
          <ion-segment [(ngModel)]="setupRecoveryPin" sxWidth="140px" mode="ios">
            <ion-segment-button value="yes">Yes</ion-segment-button>
            <ion-segment-button value="no">No</ion-segment-button>
          </ion-segment>
        </div>



      </div>

      <super-button sxWidth="full" [action]="generateEncryptionKey"
        iconEnd="arrow-forward-outline">Continue</super-button>


    </div>




  </div>
</ion-content>